import { Protocol } from "../../../models/Entities/Protocols/Protocol";
import { Person } from "../../../models/Entities/Person/Person";
import { Practitioner } from "../../../models/Entities/Practitioners/Practitioner";
import { ErrorType } from "../../../models/HttpError";

// stores
import * as MedicalProtocolStore from '../../../redux/middleware/MedicalProtocolMiddleware';
import * as PersonsStore from '../../../redux/middleware/Persons.Middleware';
import * as PractitionerStore from '../../../redux/middleware/PractitionerMiddleware';

// State
import { AppState } from "../../../redux/reducers";

interface IProps {
  SponsorId?: number;
}

interface ConnectedProps {
  isLoading: boolean;
  isLoadingSuccessfully: boolean;
  failOnLoading: boolean;
  error: ErrorType | undefined;
  MedicalProtocols: Protocol[];
  Persons: Person[];
  Practitioners: Practitioner[];
  AccessToken: string | undefined;
}

interface DispatchProps {
  GetAllMedicalProtocols: typeof MedicalProtocolStore.actionCreators.GetAllMedicalProtocols;
  GetAllPersons: typeof PersonsStore.actionCreators.GetAllPersons;
  GetAllPractitioners: typeof PractitionerStore.actionCreators.GetAllPractitioners;
}

export type Props = IProps & ConnectedProps & DispatchProps;

export const mapStateToProps = (state: AppState, _ownProps: IProps) => ({
  isLoading: state.MedicalProtocols?.isLoadingAll,
  isLoadingSuccessfully: state.MedicalProtocols?.successLoadingAll,
  failOnLoading: state.MedicalProtocols?.failOnLoadingAll,
  error: state.MedicalProtocols?.error,
  MedicalProtocols: state.MedicalProtocols?.list,
  Persons: state.Persons?.list ?? [],
  Practitioners: state.Practitioners?.list ?? [],
  AccessToken: (state as any)?.oidc?.user?.access_token as string | undefined,
});

export const mapDispatchToProps = {
  ...MedicalProtocolStore.actionCreators,
  ...PersonsStore.actionCreators,
  ...PractitionerStore.actionCreators,
};